import React, { useEffect } from "react";
import Hero from "../components/Hero";
import Partners from "../components/Partners";
import Solutions from "../components/Solutions";
import Industries from "../components/Industries";

const useReveal = () => {
  useEffect(() => {
    const els = document.querySelectorAll(".reveal");
    const obs = new IntersectionObserver(
      (entries) => entries.forEach((e) => e.isIntersecting && e.target.classList.add("visible")),
      { threshold: 0.12 }
    );
    els.forEach((el) => obs.observe(el));
    return () => obs.disconnect();
  }, []);
};

const Home = () => {
  useReveal();
  return (
    <main>
      <Hero />
      <Partners />
      <Solutions />
      <Industries />
    </main>
  );
};

export default Home;
